export default {
  UPDATE_CST_RANK: 'UPDATE_CST_RANK',
  UPDATE_FAILED: 'UPDATE_FAILED',
  UPDATE_LOADING: 'UPDATE_LOADING',
  UPDATE_REPORT_URL: 'UPDATE_REPORT_URL'
}